<template>
  <PageTemplate>
    <v-row justify="center">
      <v-col cols="12" sm="10" md="8" lg="7">
        <TitleWidget class="text-center text-sm-left">
          Trabalhe Conosco
        </TitleWidget>

        <WorkUsForm
          class="mt-12"
          :action="files + formAction"
          response-to="/trabalhe-conosco/obrigado"
        />
      </v-col>
    </v-row>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../components/templates/PageTemplate.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import WorkUsForm from "../components/forms/WorkUsForm.vue";

export default {
  data: () => ({
    formAction: "/rest/email/work-with-us",
  }),
  components: {
    PageTemplate,
    TitleWidget,
    WorkUsForm,
  },
};
</script>
